import { FETCH_COMPANIES_SUCCESS } from '../types'

export default function reduceLatestLoadedRequestKey(
  state = null,
  { type, meta: { requestKey } = {} }
) {
  if (type === FETCH_COMPANIES_SUCCESS) return requestKey
  return state
}
